import { selectUserInfo } from "features/user/userSlice";
import { Box, Grid, TextField } from "@mui/material"
import { Controller, useForm } from "react-hook-form"
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { InspectionFormItemProfileService } from "subModule/src/core/services";
import AlertMessages from "common/Alert/AlertMessages";
import { useSnackbar } from "notistack";
import SimpleModal from "common/Form/Form";
import { useNavigate, useParams } from "react-router-dom";
import ComponentHeaderTwo from "common/ComponentHeaderTwo/ComponentHeaderTwo";
import { ReactComponent as Inspection  } from "assets/SideBarIcons/inspection.svg";
import { checkPrivileges } from "Helpers/CheckPrivileges";
import { useEffect, useRef, useState } from "react";
import { GetIFIByIdResponse } from "subModule/src/services/inspectionformitem/interface";
import Loader from "layout/Loader";
import InspectionFormTabs from "./InspectionFormTabs";
// import ImageClickCoordinates from "components/InspectionFormItem/ClickableImage";
import { useGetInspectionSectionService } from "subModule/src/services/inspectionsection/useInspectionSection";
import DynamicSelect from "common/Select/Select";
import ComponentSubheader from "common/ComponentHeaderTwo/ComponentSubheader";
import { useBusinessSetupEntityBreadcrumbs } from "Helpers/useBusinessSetupEntityBreadcrumbs";
// import { GetInspectionFormByIdResponse } from "@subModule/src/services/inspectionform/interface";
// import { themes } from "theme/themes";
// import { brandingInfo } from "features/server/brandingSlice";
// import { BrandingResponse } from "@subModule/src/services/allcommon/interface";
interface FormData { [key: string]: any;}
export default function InspectionFormItemModal() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const debounceTimer = useRef<NodeJS.Timeout | null>(null);
    const { register, handleSubmit, control, formState: { errors, dirtyFields, isDirty }, reset } = useForm<FormData>({defaultValues: {
        coordinates: [149,75]
    }});
    const loggedInUserData = useSelector(selectUserInfo);
    // const branding = useSelector(brandingInfo);
    // const themeColors =
    //     (branding as BrandingResponse)?.attributes?.themeId === 100
    //       ? (branding as BrandingResponse)?.attributes?.customTheme
    //       : (themes as any)[(branding as BrandingResponse)?.attributes?.themeId || 3];
    const primaryLanguage = loggedInUserData?.business?.primaryLanguage;
    const secondaryLanguage = loggedInUserData?.business?.secondaryLanguage;
    const isArabicLanguage = (lang?: string) => {
        const l = (lang || "").toLowerCase();
        return l === "arabic" || l === "ar" || l.includes("arab");
    };
    const localizedInspectionItemPlaceholder = (lang?: string) =>
        isArabicLanguage(lang) ? t("phInspectionItemAr") : t("phInspectionItemEn");
    const [loading, setLoading] = useState<boolean>(params?.ifid ? true : false);
    const [IsBtnEnabled, setIsBtnEnabled] = useState<boolean>(params?.ifid ? false : true);
    const { breadcrumbItems, captureLabel } = useBusinessSetupEntityBreadcrumbs({
        sectionLabelKey: "general",
        moduleLabelKey: "inspectionFormItems",
        moduleHref: `/inspection-form-items/${params.id}`,
        entityFallbackLabelKey: "title",
        isEdit: !!params?.ifid,
    });
    const [dropdownSearchTerm, setDropdownSearchTerm] = useState<any>('');
    const [pageNo, setPageNo] = useState<number>(1);
    const [searchLoading, setSearchLoading] = useState<string | null>(null);
    // const [vehicleType, setVehicleType] = useState<string>('');
    const { data: sectionsData, refetch: sectionsRefetch } = useGetInspectionSectionService({ pageNumber: pageNo, size: 50, title: dropdownSearchTerm }, +(params as any)?.id);
    const sections = (sectionsData?.pages[0]?.data?.content || []).map((item: { id?: number, title?: string }) => ({ value: item.id, label: item.title }));
    useEffect(() => {
        sectionsRefetch();
        // getInspectionFormById();
    }, []);
    useEffect(() => {
        if(params?.ifid && sectionsData) {
            if(loading) getByID();
        }
    }, [params, sectionsData]);
    useEffect(() => {
        if (isDirty && params?.ifid) setIsBtnEnabled(true);
      }, [isDirty, dirtyFields]);
    const getByID = () => {
        InspectionFormItemProfileService.getInspectionFormItemById(+(params as any)?.ifid).then((res: GetIFIByIdResponse) => {
            if(res.success) {
                reset({ ...res?.data || {}, 
                    coordinates: (res?.data.coordinates as string)?.split(",")?.map(Number),
                    inspectionFormSectionId: { value: res.data?.inspectionFormSectionId, label: res.data?.inspectionFormSectionTitle || res.data?.inspectionFormSectionId },
                });
                captureLabel(res?.data?.title);
                setLoading(false);
            } else {
                enqueueSnackbar(<AlertMessages text={res.message || "Something went wrong"} />, { variant: 'error' });
            }
        }).catch((err:any) => { console.error("===", err); });
    }
    // const getInspectionFormById = () => {
    //     InspectionFormProfileService.getInspectionFormById(+(params as any)?.id).then((res: GetInspectionFormByIdResponse) => {
    //         if(res.success) {
    //             setVehicleType(res?.data?.vehicleTypeName || '');
    //             if(!params?.ifid) setLoading(false);
    //         } else {
    //             if(!params?.ifid) setLoading(false);
    //             enqueueSnackbar(<AlertMessages text={res.message || "Something went wrong"} />, { variant: 'error' });
    //         }
    //     }).catch((err:any) => { console.error("===", err); if(!params?.ifid) setLoading(false);});
    // }
    const onSubmit = (data: any) => {
        setIsBtnEnabled(false);
        if(params?.ifid) {
            InspectionFormItemProfileService.updateInspectionFormItem(+(params as any)?.ifid, { ...data, 
                inspectionFormId: +(params as any)?.id,
                inspectionFormSectionId: data.inspectionFormSectionId?.value,
                coordinates: data.coordinates.toString(),
            }).then((response: any) => {
                if(response.success) {
                    captureLabel(data?.title);
                    navigate(-1);
                    enqueueSnackbar(<AlertMessages statusCode={response.status} text={t('inspectionFormItem') + ' ' + t('updated') + ' ' + t('successfully')} />, { variant: 'success' });
                } else {
                    enqueueSnackbar(<AlertMessages text={t(response?.message)} />, { variant: 'error' });
                    setIsBtnEnabled(true);
                }
            }).catch((err:any) => { 
                console.error("===", err);
                setIsBtnEnabled(true);
                enqueueSnackbar(<AlertMessages text={err?.message || err?.data?.message || "Something went wrong"} />, { variant: 'error' });
            });
        } else {
            InspectionFormItemProfileService.createInspectionFormItem({ ...data, 
                inspectionFormId: +(params as any)?.id,
                inspectionFormSectionId: data.inspectionFormSectionId?.value,
                coordinates: data.coordinates.toString(),
             }).then((response: any) => {
                if(response.success) {
                    enqueueSnackbar(<AlertMessages statusCode={response.status} text={t('inspectionFormItem') + ' ' + t('created') + ' ' + t('successfully')} />, { variant: 'success' });
                    navigate(-1);
                } else {
                    setIsBtnEnabled(true);
                    enqueueSnackbar(<AlertMessages text={t(response?.message)} />, { variant: 'error' });
                }
            }).catch((err:any) => { 
                console.error("===", err);
                setIsBtnEnabled(true);
                enqueueSnackbar(<AlertMessages text={err?.message || err?.data?.message || "Something went wrong"} />, { variant: 'error' });
            });
        }
    };
    const handleDropdownActions = (typeName: string, action: 'searchIt' | 'loadNext', search?: string) => {
        if(action === 'searchIt') {
            setPageNo(1);
            setDropdownSearchTerm(search);
            if(search) setSearchLoading(typeName);
        } else {
            setPageNo(pageNo + 1);
            setSearchLoading(typeName);
        }
        if (debounceTimer.current) clearTimeout(debounceTimer.current);
        debounceTimer.current = setTimeout(() => {
            if(typeName === 'sections') sectionsRefetch().finally(() => setSearchLoading(null));
        }, 300);
    }
    return (<>
        <ComponentHeaderTwo
            showBtn={true}
            showSaveBtn={false}
            onClick={() => navigate(`/inspection-forms`)}
            heading={t('inspectionForms')}
            icon={<Inspection height={28} width={28} />}
            btnText={"back"}
            btnType={"back"}
            showCreateBtn={false}
            breadcrumbItems={breadcrumbItems}
        />
        <div className={`flex`}>
            <InspectionFormTabs params={params} selectedIndex={2} />
            <Box className='w-[100%] mt-[10px]'>
                <ComponentSubheader
                    showBtn={false}
                    showSaveBtn={false}
                    onClick={() => navigate(-1)}
                    onSubmit={handleSubmit(onSubmit)}
                    heading={params?.ifid ? t('editInspectionFormItem') : t('addInspectionFormItem')}
                    icon={<Inspection height={28} width={28} />}
                    btnText={"back"}
                    btnType={"back"}
                    isBtnEnabled={IsBtnEnabled}
                    showCreateBtn={checkPrivileges("ROLE_INSPECTIONFORMITEM_CREATE")}
                />
                {loading ? <Loader /> : <SimpleModal
                    visable={true}
                    title={params?.ifid ? t('editInspectionFormItem') : t('addInspectionFormItem')}
                    isButtonVisable={true}
                    isVisableBtn={IsBtnEnabled}
                    btnclosetext="Back"
                    buttonText={params?.ifid ? "update" : "submit"}
                    attBtnNotshow={false}
                    notVisableBackbtn={true}
                    showPortList={handleSubmit(onSubmit)}
                    formSubmit={handleSubmit(onSubmit)}
                    content={ 
                        <Grid container component="form" id="form" className="mb-2" spacing={3} onSubmit={handleSubmit(onSubmit)}>
                            <Grid item xs={12} md={3}>
                                <TextField 
                                    {...register("title", { validate: { required: (value) => value.trim() !== '' || t('This field is required.'), } })} 
                                    label={`${!primaryLanguage ? t('primary') : ''} ${t('title')} ${primaryLanguage ? ` (${t(primaryLanguage)})` : ''} *`}
                                    placeholder={localizedInspectionItemPlaceholder(primaryLanguage)}
                                    title={(`${!primaryLanguage ? t('primary') : ''} ${t('title')} ${primaryLanguage ? ` (${t(primaryLanguage)})` : ''} *`).replace(/\s+/g, ' ').trim()}
                                    fullWidth
                                    error={!!errors.title} 
                                    helperText={errors.title?.message as string} 
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField 
                                    {...register("secondaryTitle")} 
                                    label={`${!secondaryLanguage ? t('secondary') : ''} ${t('title')} ${secondaryLanguage ? ` (${t(secondaryLanguage)})` : ''}`}
                                    placeholder={localizedInspectionItemPlaceholder(secondaryLanguage)}
                                    title={(`${!secondaryLanguage ? t('secondary') : ''} ${t('title')} ${secondaryLanguage ? ` (${t(secondaryLanguage)})` : ''}`).replace(/\s+/g, ' ').trim()}
                                    fullWidth
                                    error={!!errors.secondaryTitle} 
                                    helperText={errors.secondaryTitle?.message as string} 
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <Controller
                                    name="inspectionFormSectionId"
                                    control={control}
                                    defaultValue={null}
                                    rules={{ required: t('This field is required.') }}
                                    render={({ field }) => (<>
                                        <DynamicSelect
                                            label={t('InspectionSection') + ' *'}
                                            {...field}
                                            options={sections}
                                            isSearchable
                                            onChange={(selectedOption: any) => field.onChange(selectedOption)}
                                            error={errors.inspectionFormSectionId?.message as string}
                                            isLoading={searchLoading === 'sections'}
                                            onInputChange={(search: string, { action }: { action: string }) => {
                                            if(action === 'input-change' || 
                                                (action !== 'set-value' && action !== 'menu-close' && action !== 'input-blur')
                                            ) handleDropdownActions("sections", 'searchIt', search);
                                            else if(action === 'input-blur' || action === 'menu-close') {
                                                if(dropdownSearchTerm || pageNo > 1) handleDropdownActions("sections", 'searchIt', '');
                                                else setDropdownSearchTerm('');
                                                setPageNo(1);
                                            }
                                            }}
                                            onMenuScrollToBottom={() => {if(!(sectionsData?.pages[0]?.data as any).last) handleDropdownActions("sections", 'loadNext')}}
                                            page={pageNo}
                                        />
                                    </>)}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField 
                                    {...register("description")} 
                                    label={t('description')}
                                    placeholder={t('phInspectionItemDescription')}
                                    title={t('description')}
                                    fullWidth
                                    error={!!errors.description} 
                                    helperText={errors.description?.message as string}
                                    InputLabelProps={{ shrink: true }}
                                    multiline
                                    rows={1}
                                    sx={{ 
                                        '& .MuiInputBase-fullWidth.MuiInputBase-multiline': { width: '100%', paddingRight: '0px', paddingBottom: 0 },
                                        '& .MuiInputBase-inputMultiline': { resize: 'vertical', minHeight: '29px' }
                                    }}
                                />
                            </Grid>
                            {/* <Grid item xs={12} md={3}>
                                <ImageClickCoordinates 
                                    src={vehicleType
                                        ? `/inspection-images/${['bus', 'suv', 'truck', 'van', 'ambulance', 'refrigerated-truck', 'heavy-truck'].includes(
                                                vehicleType?.toLowerCase()?.replace(/\s+/g, '-') || ''
                                            ) ? vehicleType?.toLowerCase()?.replace(/\s+/g, "-") : 'sedan'
                                        }.svg`
                                        : "/inspection-images/sedan.svg"} 
                                    alt='' 
                                    callback={(coordinates: number[]) => setValue('coordinates', `${coordinates}`)} 
                                    value={watch('coordinates')}
                                    setIsBtnEnabled={setIsBtnEnabled}
                                    themeColors={themeColors}
                                />
                            </Grid> */}
                        </Grid>
                    }
                />}
            </Box>
        </div>
    </>)
}